import React, { Suspense, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { setBackUrl } from 'shared/lib/backUrl';
import { actions as authActions } from 'userportal/ducks/auth';
import { userportal as routes } from 'shared/routes';
import Loading from 'userportal/pages/Loading';

const LazyProtectedRoute = ({ component: Component, componentProps }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const loggedIn = useSelector(state => state.auth.loggedIn);
  const loggedOut = useSelector(state => state.auth.loggedOut);

  useEffect(() => {
    if (!loggedIn && loggedOut !== true) {
      dispatch(authActions.loginNeeded());
    }
  }, []);

  if (loggedIn === true) {
    return (
      <Suspense fallback={<Loading />}>
        <Component {...componentProps} />
      </Suspense>
    );
  }

  setBackUrl(location);
  return <Navigate to={{ pathname: routes.login }} replace />;
};

LazyProtectedRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
  componentProps: PropTypes.object,
};

LazyProtectedRoute.defaultProps = {
  componentProps: {},
};

export default LazyProtectedRoute;
